import { WEB_URL, Phone, Mail } from "../../../lib/constants/globalConstant";
const termsData = {
  updatedOn: "1st November, 2024",
  title: "Terms and Conditions",
  description: "These Terms and Conditions outline the rules and regulations for using our services, including purchasing tokens, earning rewards, and accessing other features. By accessing or using our website and services, you agree to comply with these Terms and Conditions.",
  sections: [
    {
      title: "1. Acceptance of Terms",
      content:
        "By using our services, you confirm that you have read, understood, and agreed to these Terms and Conditions. If you do not agree with any part of these terms, you must discontinue using our website and services.",
    },
    {
      title: "2. Services Offered",
      content:
        "We provide the ability for users to purchase digital tokens, earn rewards, and participate in associated programs. All services are subject to availability and may be modified, suspended, or discontinued at our discretion without prior notice.",
    },
    {
      title: "3. Eligibility",
      list: [
        "You must be at least 18 years old to use our services.",
        "By creating an account, you confirm that the information provided is accurate, complete, and up to date.",
      ]
    },
    {
      title: "4. Token Purchases and Rewards",
      list: [
        "All token purchases are final and non-refundable unless otherwise stated.",
        "Rewards earned are subject to the terms of the rewards program, which may be updated periodically.",
        "Tokens and rewards cannot be transferred or exchanged for cash unless explicitly stated.",
      ]
    },
    {
      title: "5. User Responsibilities",
      list: [
        "You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.",
        "You agree not to use our services for any unlawful or prohibited purpose.",
      ]
    },
    {
      title: "6. Communication Consent",
      content: "By providing your contact details, you agree to receive account-related alerts and updates via text messages and emails. You can manage your preferences or opt out of non-essential communications at any time through your account settings."
    },
    {
      title: "7. Third-Party Services",
      content: "We may engage third-party providers to facilitate payments, communications, and other functionalities. While we take reasonable steps to ensure the reliability of these providers, we are not responsible for their actions or policies.",
    },
    {
      title: "8. Intellectual Property",
      content: `All content, including text, graphics, logos, and software, is the property of <a href="${WEB_URL}" target="_blank" class="text-secondaryRed">${WEB_URL}</a> or its licensors. You may not reproduce, distribute, or exploit any content without prior written consent.`,
    },
    {
      title: "9. Limitation of Liability",
      list: [
        "We strive to provide accurate and reliable services but do not guarantee uninterrupted or error-free access.",
        "To the fullest extent permitted by law, we disclaim liability for any direct, indirect, or consequential damages arising from the use or inability to use our services.",
      ]
    },
    {
      title: "10. Amendments to Terms",
      content: "We reserve the right to update or modify these Terms and Conditions at any time. Any changes will be effective immediately upon posting on this page with an updated effective date. Continued use of our services after changes constitutes your acceptance of the updated Terms and Conditions.",
    },
    {
      title: "11. Termination of Services",
      content: "We may suspend or terminate your access to our services if you violate these Terms and Conditions or engage in activities that harm our users or business operations.",
    },
    {
      title: "12. Governing Law",
      content: "These Terms and Conditions shall be governed by and construed in accordance with the laws of [insert jurisdiction].",
    },
    {
      title: "13. Contact Information",
      content:
        `If you have any questions or concerns regarding these Terms and Conditions, please contact us:`,
      list: [
        `By emailing us at <a href="mailto:${Mail}" target="_blank" class="text-secondaryRed">${Mail}</a>`,
        `By calling us at <a href="tel:+${Phone}" target="_blank" class="text-secondaryRed">${Phone}</a>`,
      ],
    }
  ],
};

export default termsData;
